import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 0 10px 0 rgba(0,0,0,0.15)",
    height: "55px",
    width: "100%",
    padding: "0px 20px",
  },
  icon: {
    cursor: "pointer",
  },

  multiContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  floraImg: {
    width: 35,
    height: 35,
  },
  multimatch_title: {
    color: "#1F8E42",
    letterSpacing: 0,
    fontWeight: 500,
  },
}));

export default useStyles;
